@let form = detailFormService.form;

@if (form) {
  <div class="flex h-full flex-col justify-between">
    <hlm-tabs [tab]="activeTab()" (tabActivated)="tabActivated($event)">
      <hlm-tabs-list>
        <button hlmTabsTrigger="general">Général</button>
        <button hlmTabsTrigger="objectifs">Objectifs</button>
        <button class="capitalize" hlmTabsTrigger="livrables">{{ traductions().livrable + 's' }}</button>
      </hlm-tabs-list>
      <div hlmTabsSeparator></div>
      <div class="pt-0" hlmTabsContent="general">
        <app-detail-general [form]="detailFormService.general" />
      </div>
      <div hlmTabsContent="objectifs">
        <app-detail-objectifs
          [cartographie]="cartographie()"
          [referentiel]="referentiel()"
          [peutModifier]="peutModifier()"
        />
      </div>
      <div hlmTabsContent="livrables">
        <app-detail-livrables
          [cartographie]="cartographie()"
          [referentiel]="referentiel()"
          [peutModifier]="peutModifier()"
        />
      </div>
    </hlm-tabs>
  </div>
}
